var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __spreadArrays = (this && this.__spreadArrays) || function () {
    for (var s = 0, i = 0, il = arguments.length; i < il; i++) s += arguments[i].length;
    for (var r = Array(s), k = 0, i = 0; i < il; i++)
        for (var a = arguments[i], j = 0, jl = a.length; j < jl; j++, k++)
            r[k] = a[j];
    return r;
};
import React from 'react';
import styled, { css } from 'styled-components';
import { SPACING_XL, BASE_BORDER_WIDTH, useStateValue, createUIElement } from "../helpers";
import { Tile } from "../Tile";
import { STACK_DIRECTION, STACK_GAP, StackView } from "../StackView";
import { Dropdown } from "../controls/Dropdown";
import { ToggleMenu, ToggleMenuItem } from "../helpers/ToggleMenu";
import * as Svg from './svg';
var WrapperTile = styled.div(templateObject_1 || (templateObject_1 = __makeTemplateObject([""], [""])));
var StyledSummaryTiles = styled.div(templateObject_2 || (templateObject_2 = __makeTemplateObject(["\n    position: relative;\n    display: flex;\n    height: 128px;\n    box-sizing: border-box;\n\n    ", " {\n        width: 100%;\n        height: 100%;\n        border-right: ", " solid ", ";\n\n        &:last-child {\n            border-right: none;\n        }\n    }\n"], ["\n    position: relative;\n    display: flex;\n    height: 128px;\n    box-sizing: border-box;\n\n    ", " {\n        width: 100%;\n        height: 100%;\n        border-right: ", " solid ", ";\n\n        &:last-child {\n            border-right: none;\n        }\n    }\n"])), WrapperTile, BASE_BORDER_WIDTH, function (_a) {
    var theme = _a.theme;
    return theme.colorBorderGrid;
});
var MenuButton = React.forwardRef(function (_a, ref) {
    var className = _a.className, onMouseDown = _a.onMouseDown;
    return (React.createElement("button", { className: className, ref: ref, onMouseDown: onMouseDown, "data-selector-id": "summarytiles-dropdown-control" },
        React.createElement(Svg.threeDots, null)));
});
var StyledMenuButton = styled(MenuButton)(templateObject_5 || (templateObject_5 = __makeTemplateObject(["\n    display: flex;\n    margin: 0 0 0 auto;\n    width: ", ";\n    height: ", ";\n    border: none;\n    background: none;\n    padding: 0;\n    align-items: center;\n\n    &:active {\n        outline: none;\n    }\n\n    ", "\n\n    ", "\n"], ["\n    display: flex;\n    margin: 0 0 0 auto;\n    width: ", ";\n    height: ", ";\n    border: none;\n    background: none;\n    padding: 0;\n    align-items: center;\n\n    &:active {\n        outline: none;\n    }\n\n    ",
    "\n\n    ",
    "\n"])), SPACING_XL, SPACING_XL, function (_a) {
    var theme = _a.theme;
    return css(templateObject_3 || (templateObject_3 = __makeTemplateObject(["\n        &:hover {\n            background: ", ";\n        }\n    "], ["\n        &:hover {\n            background: ", ";\n        }\n    "])), theme.colorHighlightLight);
}, function (_a) {
    var isActive = _a.isActive, theme = _a.theme;
    return isActive && css(templateObject_4 || (templateObject_4 = __makeTemplateObject(["\n            background: ", ";\n\n            &:hover {\n                background: ", ";\n            }\n        "], ["\n            background: ", ";\n\n            &:hover {\n                background: ", ";\n            }\n        "])), theme.colorHighlightDark, theme.colorHighlightDark);
});
export var SummaryTiles = createUIElement('SummaryTiles', function (_a, ref) {
    var className = _a.className, selectedItems = _a.selectedItems, items = _a.items, onChange = _a.onChange, onClick = _a.onClick, onMouseDown = _a.onMouseDown, onMouseUp = _a.onMouseUp, onMouseEnter = _a.onMouseEnter, onMouseLeave = _a.onMouseLeave, onKeyDown = _a.onKeyDown, onKeyUp = _a.onKeyUp, onKeyPress = _a.onKeyPress, style = _a.style, rest = __rest(_a, ["className", "selectedItems", "items", "onChange", "onClick", "onMouseDown", "onMouseUp", "onMouseEnter", "onMouseLeave", "onKeyDown", "onKeyUp", "onKeyPress", "style"]);
    selectedItems = Array.from(new Set(selectedItems)) || [];
    var _b = useStateValue(selectedItems, [selectedItems]), getValue = _b.getValue, setValue = _b.setValue;
    var updateValue = function (id, isChecked) {
        var currentValue = __spreadArrays(getValue());
        var isIdSelected = currentValue.includes(id);
        if (!isChecked && isIdSelected) {
            return currentValue.filter(function (i) { return i !== id; });
        }
        if (isChecked && !isIdSelected) {
            currentValue.push(id);
        }
        return currentValue;
    };
    var handleChangeItem = function (id, isChecked) {
        var newValue = updateValue(id, isChecked);
        setValue(newValue);
        onChange === null || onChange === void 0 ? void 0 : onChange(newValue);
    };
    var options = [];
    var tiles = items &&
        items.map(function (_a, idx) {
            var id = _a.id, tileProps = __rest(_a, ["id"]);
            var title = tileProps.title;
            var isChecked = getValue().includes(id);
            options.push(React.createElement(ToggleMenuItem, { key: "summarytiles-option-" + idx, "data-selector-id": "summarytiles-option-" + idx, title: title, isChecked: isChecked, onChange: function (isChecked) { return handleChangeItem(id, isChecked); } }));
            return (isChecked && (React.createElement(WrapperTile, { key: "summarytiles-wrapper-tile" + id + "-" + idx },
                React.createElement(Tile, __assign({ "data-selector-id": "summarytiles-wrapper-tile" + idx }, tileProps)))));
        });
    return (React.createElement(StackView, __assign({}, rest, { "data-selector-id": rest['data-selector-id'] || 'summarytiles-wrapper', className: "vm-SummaryTiles " + className, direction: STACK_DIRECTION.column, gap: STACK_GAP.none, onClick: onClick, onMouseDown: onMouseDown, onMouseUp: onMouseUp, onMouseEnter: onMouseEnter, onMouseLeave: onMouseLeave, onKeyDown: onKeyDown, onKeyUp: onKeyUp, onKeyPress: onKeyPress, ref: ref, style: style }),
        React.createElement(Dropdown, { renderControl: function (_a) {
                var button = _a.button, isActive = _a.isActive;
                return (React.createElement(StyledMenuButton, __assign({}, button, { isActive: isActive })));
            }, renderPopover: function (_a) {
                var popover = _a.popover, content = _a.content;
                return React.createElement("div", __assign({}, popover), content);
            }, renderContent: function () { return React.createElement(ToggleMenu, null, options); } }),
        React.createElement(StyledSummaryTiles, null, tiles)));
});
var templateObject_1, templateObject_2, templateObject_3, templateObject_4, templateObject_5;
//# sourceMappingURL=SummaryTiles.js.map